<h1 class={$$props.class}>
  <slot></slot>
</h1>

<style lang="scss">
  h1 {
    word-break: break-word;
    font-size: min(36px, 8.5vw);
    line-height: min(36px, 8.5vw);
  }
</style>